// Table.js — DROP-IN
import React from "react";
import { useTable } from "react-table";
import "bootstrap/dist/css/bootstrap.min.css";
import BTable from "react-bootstrap/Table";
import Loader from "./Loader";

export default function Table({
  columns,
  data,
  isLoading,
  manualPagination = false,
  onRowClick,
  onClearFilters,
}) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, visibleColumns } =
    useTable({ columns, data, manualPagination });

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <BTable striped bordered hover className="align-middle" size="sm" {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.length === 0 ? (
              <tr className="table-empty-row" key="empty">
                <td
                  colSpan={
                    (visibleColumns && visibleColumns.length) ||
                    headerGroups[0]?.headers?.length ||
                    (Array.isArray(columns) ? columns.length : 1)
                  }
                >
                  <div className="table-empty-cell" role="status" aria-live="polite">
                    <div className="empty-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" width="22" height="22">
                        <path
                          d="M10 2a8 8 0 105.293 14.293l4.207 4.207 1.414-1.414-4.207-4.207A8 8 0 0010 2zm0 2a6 6 0 110 12A6 6 0 0110 4z"
                          fill="currentColor"
                        />
                      </svg>
                    </div>
                    <div className="empty-title">No matches found</div>
                    {typeof onClearFilters === "function" && (
                      <div className="empty-actions">
                        <button type="button" className="btn-reset" onClick={onClearFilters}>
                          Clear all filters
                        </button>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ) : (
              rows.map((row, i) => {
                const original = row.original;

                // Date header row
                if (original && original.__isDateHeader) {
                  const colSpan =
                    (visibleColumns && visibleColumns.length) ||
                    headerGroups[0]?.headers?.length ||
                    row.cells.length;

                  return (
                    <tr className="day-sep" key={`day-${original.__dateKey}-${i}`}>
                      <td colSpan={colSpan}>
                        <div className="day-sep__inner">{original.__label}</div>
                      </td>
                    </tr>
                  );
                }

                // Normal data row
                prepareRow(row);

                // Typed highlight if available; otherwise legacy row-alert for any alert
                const a = row.original?.alert;
                const typedColor = a?.type_color_hex || null;
                const isOnList = a?.on_list || row.original?.isAlert;

                const className = typedColor
                  ? "row-alert-typed"
                  : isOnList
                  ? "row-alert"
                  : undefined;

                const style = typedColor ? { "--alert-row-bg": typedColor } : undefined;

                return (
                  <tr
                    {...row.getRowProps()}
                    onClick={() => onRowClick && onRowClick(row.original)}
                    className={className}
                    style={style}
                    aria-label={isOnList ? "Alert vehicle" : undefined}
                  >
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    ))}
                  </tr>
                );
              })
            )}
          </tbody>
        </BTable>
      )}
    </>
  );
}
